import { signal } from "@angular/core";
import { disabled, SchemaPathTree } from "@angular/forms/signals";
import { PeriodDefinitionType } from "@models/map/market-filter.model";

export interface EstateTypeModel {
    estateType: EVEstateFilterType;
    index: number;
    selected: boolean;
    other: boolean;
}

export enum EVEstateFilterType {
    Ukjent = "Ukjent",
    Enebolig = "Enebolig",
    Rekkehus = "Rekkehus",
    Leilighet = "Leilighet",
    Hybel = "Hybel",
    Fritidsbolig = "Fritidsbolig",
    Tomannsbolig = "Tomannsbolig",
    Boligtomt = "Boligtomt",
    Hyttetomt = "Hyttetomt",
    Skole = "Skole/barnehage",
    Næring = "Næring",
    Landbruk = "Landbruk",
    Bolig = "Bolig",
    Hus = "Hus",
    DeltBolig = "Delt bolig",
    Garasje = "Garasje",
    Ubebygd = "Ubebygd",
    Offentlig = "Offentlig",
    Helse = "Helse",
    MediaKomm = "Media/komm",
    KulturIdrett = "Kultur og idrett",
    Religion = "Religion",
    Transport = "Transport",
    Annet = "Annet",
}

const defaultEstateTypes: EstateTypeModel[] = [
    {
        estateType: EVEstateFilterType.Enebolig,
        index: 2,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Rekkehus,
        index: 3,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Leilighet,
        index: 4,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Tomannsbolig,
        index: 7,
        selected: true,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Fritidsbolig,
        index: 6,
        selected: false,
        other: false,
    },
    {
        estateType: EVEstateFilterType.Annet,
        index: 27,
        selected: false,
        other: true,
    },
];

export interface SearchViewOptionsFilterModel {
    estateTypes: EstateTypeModel[];
    isSitePrice: boolean;
    expanded: boolean;
    periodDefinitionType: number;
    includeJudicialTransfers: boolean;
    includeAgentSales: boolean;
    includeWithDrawnPrices: boolean;
    isForSale: boolean;
    isOwnedByCompany: boolean;
    includeUnCertainPrices: boolean;
    includeOnlyEstateAgencySales: boolean;
    estateAgentHeadOfficeId?: number; 
}

export function createSearchViewOptionsModel() {
    return signal<SearchViewOptionsFilterModel>({
        estateTypes: defaultEstateTypes,
        expanded: true,
        isSitePrice: false,
        periodDefinitionType: 3,
        includeJudicialTransfers: true,
        includeAgentSales: true,
        includeWithDrawnPrices: false,
        isForSale: false,
        isOwnedByCompany: false,
        includeUnCertainPrices: true, 
        includeOnlyEstateAgencySales: false,
        estateAgentHeadOfficeId: null
    });
}

export function buildSearchViewOptionsModel(a: SchemaPathTree<SearchViewOptionsFilterModel>) {
    // disabled fields should not be clickable
    disabled(a.isForSale, (ctx) => !ctx.valueOf(a.includeAgentSales) || isSoldPeriod(ctx.valueOf(a.periodDefinitionType)) || ctx.valueOf(a.includeWithDrawnPrices));

    disabled(
        a.includeWithDrawnPrices,
        (ctx) => !ctx.valueOf(a.includeAgentSales) || isSoldPeriod(ctx.valueOf(a.periodDefinitionType)) || ctx.valueOf(a.isForSale),
    );

    disabled(a.includeOnlyEstateAgencySales, (ctx) => !ctx.valueOf(a.includeAgentSales));
}

function isSoldPeriod(periodDefinitionType: number): boolean {
    return periodDefinitionType === PeriodDefinitionType.Sold;
}
